import axios from "axios";

const ajaxClient = axios.create({
  headers: {
    "Content-Type": "multipart/form-data"
  }
});

export default {
  uploadFiles(url, formData, config) {
    return ajaxClient.post(url, formData, config).then(
      (response) => {
        return response.data;
      },
      (error) => {
        return {
          success: false
        };
      }
    );
  }
};
